module.exports = __webpack_public_path__ + "images/161_640.jpg";